import PropTypes, {string, object, bool} from "prop-types"
import React from "react"
import Styled from "styled-components"
import {text} from "@uprise/typography"
import {backgrounds} from "@uprise/colors"

const LinkStyles = Styled.a`
	color: ${props => props.color};
	font-size: ${props => props.fontSize};
	display: inline-block;
	margin: ${props => props.margin};
	text-decoration: ${props => (props.underline ? "underline" : "none")};
	text-transform: ${props => (props.uppercase ? "uppercase" : "none")}

	&:hover {
		cursor: pointer;
		color: ${props => props.colorHover};
		transition: all 0.4s;
	}

	@media (max-width: 1024px) {
		font-size: ${props => props.fontSize};
		color: ${backgrounds.white};
	}

	@media (max-width: 1024px) {
		&:hover {
			font-size: ${props => props.fontSizeHover};
			color: ${backgrounds.white};
		}
	}
`

const Link = ({className, link, color, margin, fontSize, fontSizeHover, colorHover, underline, uppercase}) => {
	// prefix link with `/` if not present
	const navItemLink = link && link.link && link.link.trim()
	const fullURLWithProtocol = navItemLink && navItemLink.split(":").length >= 2
	if (navItemLink && navItemLink.length !== 0 && navItemLink[0] !== "/" && !fullURLWithProtocol) {
		link.link = `/${navItemLink}`
	}

	return (
		<LinkStyles
			className={className}
			uppercase={uppercase}
			href={link.link}
			color={color}
			colorHover={colorHover}
			margin={margin}
			fontSize={fontSize}
			fontSizeHover={fontSizeHover}
			underline={underline}>
			{link.title}
		</LinkStyles>
	)
}

export default Link

Link.propTypes = {
	link: object,
	color: string,
	margin: string,
	underline: bool
}

Link.defaultProps = {
	underline: false,
	fontSize: text.t6
}
